import { render } from "./GerarCartaPropostaOrcamento.vue?vue&type=template&id=6a4bd18c&scoped=true"
import script from "./GerarCartaPropostaOrcamento.vue?vue&type=script&lang=js"
export * from "./GerarCartaPropostaOrcamento.vue?vue&type=script&lang=js"

import "./GerarCartaPropostaOrcamento.vue?vue&type=style&index=0&id=6a4bd18c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4bd18c"]])

export default __exports__